import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, Youtube } from "lucide-react";
import logo from "../../assets/brand/pintarpilihkuliah-wordmark.png";
import settings from "../../constants/settings";
import { trackEvent } from "../../utils/analyticsUtils";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__about">
          <Link to="/" aria-label="#PintarPilihKuliah, beranda">
            <img
              src={logo}
              alt="#PintarPilihKuliah"
              width="1081"
              height="265"
            />
          </Link>
          <p>
            Program mentoring untuk membantu pelajar memilih peluang beasiswa
            dan menyiapkan pendaftaran secara terarah.
          </p>
        </div>

        <nav className="site-footer__links" aria-label="Tautan program">
          <strong>Program</strong>
          <Link to="/#paket-semua-wilayah">Semua Wilayah</Link>
          <Link to="/#program-wilayah">Indonesia</Link>
          <Link to="/#program-wilayah">Asia Pasifik</Link>
          <Link to="/#program-wilayah">Timur Tengah</Link>
          <Link to="/#program-wilayah">Eropa</Link>
          <Link to="/#kisah-siswa">Cerita Alumni</Link>
        </nav>

        <div className="site-footer__contact">
          <strong>Butuh bantuan memilih?</strong>
          <p>
            Masih bingung memilih program? Konsultasikan tujuanmu melalui
            WhatsApp.
          </p>
          <a
            href={settings.wa_consultant_prefilled_link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("Conversion", "whatsapp_click", "footer")}
          >
            <MessageCircle size={18} aria-hidden="true" />
            Tanya Admin
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>
          © {new Date().getFullYear()} #PintarPilihKuliah. Hak cipta
          dilindungi.
        </p>
        <div aria-label="Media sosial">
          <a
            href="mailto:info@pintarpilihkuliah.com"
            aria-label="Email #PintarPilihKuliah"
          >
            <Mail size={18} aria-hidden="true" />
          </a>
          <a
            href={settings.social_media.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram #PintarPilihKuliah"
          >
            <Instagram size={18} aria-hidden="true" />
          </a>
          <a
            href={settings.social_media.youtube}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube #PintarPilihKuliah"
          >
            <Youtube size={18} aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
